import { NgModule } from '@angular/core';
import { AsyncPipe, CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { LuxonModule } from 'luxon-angular';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { InputTextModule } from 'primeng/inputtext';
import { DividerModule } from 'primeng/divider';
import { ButtonModule } from 'primeng/button';
import { InputMaskModule } from 'primeng/inputmask';
import { NgSelectModule } from '@ng-select/ng-select';
import { ControlRequiredPipeModule } from './pipes/controlRequiredPipe/controlRequiredPipe.module';
import { PasswordModule } from 'primeng/password';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ColorPickerModule } from 'primeng/colorpicker';
import { FindLanguageFromKeyPipeModule } from './pipes/findLanguageFromKeyPipe/findLanguageFromKeyPipe.module';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/multiselect';
import { RouterModule } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { ToastrModule } from 'ngx-toastr';
import { SplitterModule } from 'primeng/splitter';
import { SkeletonModule } from 'primeng/skeleton';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { DeferModule } from 'primeng/defer';
import { SpeedDialModule } from 'primeng/speeddial';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { CheckboxModule } from 'primeng/checkbox';
import { MenuModule } from 'primeng/menu';
import { MatMenuModule } from '@angular/material/menu';
import { BlockUIModule } from 'primeng/blockui';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ListboxModule } from 'primeng/listbox';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { CardModule } from 'primeng/card';
import { FilterPipeModule } from './pipes/filterPipe/filterPipe.module';
import { TextareaModule } from 'primeng/textarea';
import { ScrollerModule } from 'primeng/scroller';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ButtonAllModule } from '@syncfusion/ej2-angular-buttons';
import {
	BarcodeGeneratorAllModule,
	QRCodeGeneratorAllModule,
} from '@syncfusion/ej2-angular-barcode-generator';
import { MessageModule } from 'primeng/message';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { CalendarAllModule } from '@syncfusion/ej2-angular-calendars';
import {
	NumericTextBoxAllModule,
	OtpInputAllModule,
	TextAreaAllModule,
	TextBoxAllModule,
} from '@syncfusion/ej2-angular-inputs';
import { SplitButtonAllModule } from '@syncfusion/ej2-angular-splitbuttons';
import { GridAllModule } from '@syncfusion/ej2-angular-grids';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { SelectModule } from 'primeng/select';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { PrettyJsonPipeModule } from './pipes/prettyJsonPipe/prettyJsonPipe.module';

@NgModule({
	imports: [
		//Primeng
		ToastModule,
		ToastrModule.forRoot(),

		//Angular
		AsyncPipe,
	],
	exports: [
		//Angular
		FormsModule,
		CommonModule,
		ReactiveFormsModule,
		RouterModule,
		ScrollingModule,

		//Bootstrap
		NgbModule,

		//NgxInfinite
		InfiniteScrollModule,

		//FontAwesome
		FontAwesomeModule,

		//Translate
		TranslateModule,

		//Luxon
		LuxonModule,

		//Material
		MatFormFieldModule,
		MatIconModule,
		MatInputModule,
		MatSlideToggleModule,
		MatButtonModule,
		MatSidenavModule,
		MatMenuModule,

		//NgSelect
		NgSelectModule,

		//PDFViewer
		PdfViewerModule,

		//Syncfusion
		BarcodeGeneratorAllModule,
		QRCodeGeneratorAllModule,
		ButtonAllModule,
		CalendarAllModule,
		DropDownListAllModule,
		GridAllModule,
		OtpInputAllModule,
		SplitButtonAllModule,
		TextAreaAllModule,
		TextBoxAllModule,
		NumericTextBoxAllModule,

		//PrimeNg
		MessageModule,
		InputTextModule,
		DividerModule,
		ButtonModule,
		InputMaskModule,
		PasswordModule,
		ColorPickerModule,
		ConfirmDialogModule,
		TableModule,
		MultiSelectModule,
		ToggleSwitchModule,
		ToastModule,
		SplitterModule,
		SkeletonModule,
		DeferModule,
		SpeedDialModule,
		AvatarModule,
		AvatarGroupModule,
		CheckboxModule,
		MenuModule,
		BlockUIModule,
		ScrollerModule,
		TextareaModule,
		ListboxModule,
		OverlayPanelModule,
		CardModule,
		IconFieldModule,
		InputIconModule,
		MenuModule,
		InputGroupModule,
		InputGroupAddonModule,
		SelectModule,
		BreadcrumbModule,

		//Pipes
		ControlRequiredPipeModule,
		FindLanguageFromKeyPipeModule,
		FilterPipeModule,
		PrettyJsonPipeModule,
	],
	providers: [], //Moved to CoreInternal
})
export class SharedLibsModule {}
